document.addEventListener("DOMContentLoaded", function () {
  let splide1;

  function initSplide1() {
    if (window.innerWidth <= 768) {
      if (!splide1) {
        splide1 = new Splide("#news-splide", {
          classes: {
            pagination: "splide__pagination",
            page: "splide__pagination__page",
          },
          type: "loop",
          focus: "center",
          arrows: false,
          pagination: true,
          gap: 16,
          perPage: 1,
          padding: "8%",
          autoScroll: {
            speed: 0.5,
            pauseOnHover: false,
            pauseOnFocus: false,
          },
        }).mount();
      }
    } else {
      if (splide1) {
        splide1.destroy();
        splide1 = null;
      }
    }
  }

  // 初期化
  initSplide1();

  // ウィンドウのリサイズ時にスライダーを再初期化
  window.addEventListener("resize", initSplide1);
});

document.addEventListener("DOMContentLoaded", function () {
  let splide2;

  function initSplide2() {
    if (window.innerWidth <= 768) {
      if (!splide2) {
        splide2 = new Splide("#news-splide2", {
          classes: {
            pagination: "splide__pagination",
            page: "splide__pagination__page",
          },
          type: "loop",
          focus: "center",
          arrows: true,
          pagination: true,
          gap: 24,
          perPage: 1,
          padding: "20%",
          autoScroll: {
            speed: 0.5,
            pauseOnHover: false,
            pauseOnFocus: false,
          },
        }).mount();
      }
    } else {
      if (splide2) {
        splide2.destroy();
        splide2 = null;
      }
    }
  }

  // 初期化
  initSplide2();

  // ウィンドウのリサイズ時にスライダーを再初期化
  window.addEventListener("resize", initSplide2);
});